import {
    Alert,
    Box, Button,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import {Add, HelpOutline} from "@mui/icons-material";
import React from "react";

export default function HeaderSection(props) {
    const {
        headerType,
        setHeaderType,
        headerText,
        setHeaderText,
        headerTextVariable,
        setHeaderTextVariable,
        handleFileChange,
        headerMedia,
        headerMediaError,
        lat,
        setLat,
        lng,
        setLng,
        locName,
        setLocName,
        locAddress,
        setLocAddress,
        HEADER_LIMIT,
    } = props;

    return (
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
            <Stack gap={2}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <Typography variant="h6">Header</Typography>
                    <Chip label="Optional" size="small"/>
                    <Tooltip title="Add a 60 character title or media to your message.">
                        <HelpOutline fontSize="small"/>
                    </Tooltip>
                </Stack>

                <FormControl fullWidth>
                    <InputLabel id="header-type">Select</InputLabel>
                    <Select
                        labelId="header-type"
                        label="Select"
                        value={headerType}
                        onChange={(e) => {
                            setHeaderType(e.target.value);
                        }}
                    >
                        <MenuItem value="none">None</MenuItem>
                        <MenuItem value="text">Text</MenuItem>
                        <MenuItem value="image">Image</MenuItem>
                        <MenuItem value="video">Video</MenuItem>
                        <MenuItem value="document">Document</MenuItem>
                        <MenuItem value="location">Location</MenuItem>
                    </Select>
                </FormControl>

                {headerType === "text" && (
                    <>
                        <TextField
                            placeholder="Texto del encabezado"
                            value={headerText}
                            onChange={(e) => setHeaderText(e.target.value.slice(0, HEADER_LIMIT))}
                            helperText={`${headerText.length}/${HEADER_LIMIT}`}
                            inputProps={{maxLength: HEADER_LIMIT}}
                            fullWidth
                            size="small"
                        />
                        {headerText.includes("{{1}}") && (
                            <Box>
                                <Typography variant="body2" color="text.secondary" mb={1}>
                                    Define sample variable value for header
                                </Typography>
                                <TextField
                                    placeholder="Valor de ejemplo para la variable"
                                    value={headerTextVariable}
                                    onChange={(e) => setHeaderTextVariable(e.target.value)}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                        )}
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Add/>}
                            sx={{mt: 1}}
                            onClick={() =>
                                setHeaderText((h) => h + (h && !h.endsWith(" ") ? " " : "") + "{{1}}")
                            }
                            disabled={headerText.includes("{{1}}")}
                        >
                            Add variable
                        </Button>
                    </>
                )}

                {headerType === "image" && (
                    <>
                        <Typography variant="body2">Add Sample Media* — PNG/JPEG (≤ 5 MB)</Typography>
                        <Button variant="outlined" component="label">
                            Choose File
                            <input hidden type="file" accept="image/png,image/jpeg" onChange={handleFileChange}/>
                        </Button>
                        {headerMedia && <Typography variant="caption">{headerMedia.name}</Typography>}
                        {headerMediaError && <Alert severity="error">{headerMediaError}</Alert>}
                    </>
                )}
                {headerType === "video" && (
                    <>
                        <Typography variant="body2">Add Sample Media* — MP4 (≤ 16 MB)</Typography>
                        <Button variant="outlined" component="label">
                            Choose File
                            <input hidden type="file" accept="video/mp4" onChange={handleFileChange}/>
                        </Button>
                        {headerMedia && <Typography variant="caption">{headerMedia.name}</Typography>}
                        {headerMediaError && <Alert severity="error">{headerMediaError}</Alert>}
                    </>
                )}
                {headerType === "document" && (
                    <>
                        <Typography variant="body2">Add Sample Media* — PDF (≤ 100 MB)</Typography>
                        <Button variant="outlined" component="label">
                            Choose File
                            <input hidden type="file" accept="application/pdf" onChange={handleFileChange}/>
                        </Button>
                        {headerMedia && <Typography variant="caption">{headerMedia.name}</Typography>}
                        {headerMediaError && <Alert severity="error">{headerMediaError}</Alert>}
                    </>
                )}
                {headerType === "location" && (
                    <Stack gap={1}>
                        <TextField label="Latitude" type="number" value={lat} onChange={(e) => setLat(e.target.value)}
                                   fullWidth/>
                        <TextField label="Longitude" type="number" value={lng} onChange={(e) => setLng(e.target.value)}
                                   fullWidth/>
                        <TextField label="Location Name" value={locName} onChange={(e) => setLocName(e.target.value)}
                                   fullWidth/>
                        <TextField label="Address" value={locAddress} onChange={(e) => setLocAddress(e.target.value)}
                                   fullWidth/>
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
}